module.exports = __webpack_public_path__ + "static/media/timeline-2005.7d1ed295.webp";